export const CHECK_BASKET_VALUES = 'CHECK_BASKET_VALUES';

export const checkBasketValues = () => ({
    type: CHECK_BASKET_VALUES,
})